<template>
    <div class="app-container pagebouteilles">
        <el-row class="toprow is-text-align-right">
            <el-select
                v-model="activeAllocationId"
                placeholder="Select"
                style="width: 300px"
            >
                <el-option
                    v-for="allocation in allocations"
                    :key="'liv' + allocation.id"
                    :label="
                        allocation.annee +
                            '/' +
                            (parseInt(allocation.annee) + 1).toString() +
                            ' - ' +
                            etats[allocation.etat] +
                            ' (' +
                            allocation.max +
                            ' bout.)'
                    "
                    :value="allocation.id"
                />
            </el-select>
        </el-row>
        <el-row class="toprow is-text-align-right">
            <el-tooltip content="Nouvelle famille">
                <el-link
                    type="success"
                    size="small"
                    icon="el-icon-plus"
                    @click="createFamille()"
                />
            </el-tooltip>
        </el-row>
        <ul class="familles">
            <draggable
                :list="familles"
                class="board-column-content"
                @end="endDragFamilles($event)"
            >
                <li
                    v-for="(famille, index) in familles"
                    :id="famille.id"
                    :key="'fa_' + index"
                >
                    <div class="head">
                        <h3>{{ famille.nom }} ({{ famille.max }} max)</h3>
                        <span class="controls">
                            <el-tooltip content="Éditer Famille">
                                <el-link
                                    type="primary"
                                    icon="el-icon-edit"
                                    :underline="false"
                                    @click="editFamille(famille)"
                                />
                            </el-tooltip>
                            <el-tooltip content="Nouveau vin">
                                <el-link
                                    type="primary"
                                    icon="el-icon-plus"
                                    :underline="false"
                                    @click="createVin(famille)"
                                />
                            </el-tooltip>
                        </span>
                    </div>
                    <ul class="vins">
                        <draggable
                            :list="vinsFam(famille.id)"
                            class="board-column-content"
                            @end="endDragVins($event)"
                        >
                            <li
                                v-for="(vin, indexvin) in vinsFam(famille.id)"
                                :id="vin.id"
                                :key="'vi_' + indexvin"
                            >
                                <div class="head">
                                    <h4>{{ vin.nom }} ({{ vin.max }} max)</h4>
                                    <span class="controls">
                                        <el-tooltip content="Éditer vin">
                                            <el-link
                                                type="primary"
                                                icon="el-icon-edit"
                                                :underline="false"
                                                @click="editVin(vin)"
                                            />
                                        </el-tooltip>
                                        <el-tooltip content="Nouveau millésime">
                                            <el-link
                                                type="primary"
                                                icon="el-icon-plus"
                                                :underline="false"
                                                @click="createBouteille(vin)"
                                            />
                                        </el-tooltip>
                                    </span>
                                </div>
                                <ul class="bouteilles">
                                    <li
                                        v-for="(bouteille,
                                        indexbouteille) in bouteillesVin(
                                            vin.id
                                        )"
                                        :id="bouteille.id"
                                        :key="'bout_' + indexbouteille"
                                        :class="getclass(bouteille)"
                                    >
                                        <el-tooltip content="Éditer millésime">
                                            <el-link
                                                type="primary"
                                                :underline="false"
                                                @click="
                                                    editBouteille(bouteille)
                                                "
                                            >
                                                <el-card
                                                    :body-style="{
                                                        padding: '0px'
                                                    }"
                                                    class="bouteillecard"
                                                >
                                                    <el-image
                                                        v-if="bouteille.photo"
                                                        class="bouteille"
                                                        :src="
                                                            bouteille.photo_url
                                                                .mini
                                                        "
                                                        fit="scale-down"
                                                    />
                                                    <div v-else class="vide" />
                                                    <div class="controls">
                                                        <h4>
                                                            <span v-if="bouteille.ismagnum">
                                                                Magnum
                                                            </span>
                                                            {{
                                                                bouteille.millesime
                                                            }} ({{
                                                                bouteille.max
                                                            }}max)
                                                        </h4>
                                                        <p
                                                            v-if="
                                                                bouteille.etat ===
                                                                    'masqued'
                                                            "
                                                        >
                                                            masquée
                                                        </p>
                                                        <p
                                                            v-else-if="
                                                                bouteille.etat ===
                                                                    'epuise'
                                                            "
                                                        >
                                                            épuisée
                                                        </p>
                                                        <p v-else>
                                                            <span
                                                                class="commanded"
                                                            >
                                                                {{
                                                                    bouteille.commanded
                                                                }}
                                                            </span>
                                                            /
                                                            <span class="stock">
                                                                {{
                                                                    bouteille.stock
                                                                }}
                                                            </span>
                                                        </p>
                                                        <p>
                                                            {{
                                                                bouteille.prixttc
                                                                    | formatPrix
                                                            }}
                                                            € ttc
                                                        </p>
                                                    </div>
                                                </el-card>
                                            </el-link>
                                        </el-tooltip>
                                    </li>
                                </ul>
                            </li>
                        </draggable>
                    </ul>
                </li>
            </draggable>
        </ul>
        <famille
            :isvisible="dialogFamilleVisible"
            :famille="activeFamille"
            :parent="this"
        />
        <vin :isvisible="dialogVinVisible" :vin="activeVin" :parent="this" />
        <bouteille
            v-if="allocations"
            :isvisible="dialogBouteilleVisible"
            :bouteille="activeBouteille"
            :allocations="allocations"
            :parent="this"
        />
    </div>
</template>

<script>
import Resource from "@/api/resource";
const familleResource = new Resource("familles");
const vinResource = new Resource("vins");
const bouteilleResource = new Resource("bouteilles");
const allocationResource = new Resource("allocations");
import famille from "@/components/Famille";
import vin from "@/components/Vin";
import bouteille from "@/components/Bouteille";
import draggable from "vuedraggable";

export default {
    name: "Bouteilles",
    components: {
        famille,
        vin,
        bouteille,
        draggable
    },
    data() {
        return {
            loading: false,
            familles: null,
            dialogFamilleVisible: false,
            activeFamille: {},
            vins: null,
            dialogVinVisible: false,
            activeVin: {},
            bouteilles: null,
            dialogBouteilleVisible: false,
            activeBouteille: {},
            allocations: null,
            activeAllocation: {},
            activeAllocationId: null,
            etats: {
                encours: "En cours",
                finalisee: "Finalisée",
                attente: "En attente"
            },
        };
    },
    created() {
        console.log("getFamilles");
        this.getFamilles();
        this.getVins();
        this.getAllocations();
   },
    watch: {
        activeAllocationId(val) {
            if (val && this.allocations) {
                this.activeAllocation = this.allocations.find(
                    allocation => allocation.id === val
                );
                console.log("cherche paniers ALLOCATION:");
                console.log(this.activeAllocationId);
                console.log(this.activeAllocation);

                this.getBouteilles(val);
            }
        }
    },
    methods: {
        getclass(bouteille) {
            if (bouteille.etat === "masqued") {
                return "masqued";
            }
            if (
                bouteille.etat === "epuise" ||
                bouteille.stock - bouteille.commanded <= 0
            ) {
                return "epuise";
            }
            if (bouteille.etat === "envente") {
                return "envente";
            }
        },
        createFamille() {
            console.log("createFamille");
            this.activeFamille = {
                nom: "",
                id: null,
                max: 8,
                description: ""
            };
            this.dialogFamilleVisible = true;
        },
        editFamille(famille) {
            console.log("editFamille");
            this.activeFamille = famille;
            this.dialogFamilleVisible = true;
        },
        createVin(famille) {
            console.log("createVin");
            this.activeVin = {
                famille_id: famille.id,
                id: null,
                nom: null,
                max: 8,
                photo: "",
                photo_back: "",
                description: null
            };
            this.dialogVinVisible = true;
        },
        editVin(vin) {
            console.log("editVin");
            this.activeVin = vin;
            this.dialogVinVisible = true;
        },
        createBouteille(vin) {
            console.log("createBouteille");
            this.activeBouteille = {
                vin_id: vin.id,
                id: null,
                millesime: "2017",
                description: "",
                photo: "",
                max: 8,
                prix: 0,
                prixttc: 0,
                stock: 0,
                photo_back: "",
                etat: "envente"
            };
            this.dialogBouteilleVisible = true;
        },
        editBouteille(bouteille) {
            console.log("editBouteille");
            this.activeBouteille = bouteille;
            this.dialogBouteilleVisible = true;
        },
        async getFamilles() {
            console.log("getFamilles");
            this.loading = true;
            const { data } = await familleResource.list({});
            this.familles = data;
            this.loading = false;
            console.log(this.familles);
        },
        async getVins() {
            console.log("getVins");
            this.loading = true;
            const { data } = await vinResource.list({});
            this.vins = data;
            this.loading = false;
            console.log(this.vins);
        },
        async getBouteilles(allocation_id) {
            console.log("getBouteilles");
            this.loading = true;
            const { data } = await bouteilleResource.list({'allocation_id': allocation_id});
            this.bouteilles = data;
            this.loading = false;
            console.log(this.bouteilles);
        },
        async getAllocations() {
            console.log("getAllocations");
            this.activeAllocation = null;
            this.activeAllocationId = null;
            this.loading = true;
            const { data } = await allocationResource.list({});
            this.allocations = data;
            this.activeAllocation = data[0];
            this.activeAllocationId = data[0].id;
            this.loading = false;
            console.log("ALLOCATIONS");
            console.log(this.allocations);
        },
        vinsFam(famille_id) {
            if (this.vins) {
                return this.vins.filter(vin => vin.famille_id === famille_id);
            }
            return [];
        },
        bouteillesVin(vin_id) {
            if (this.bouteilles) {
                return this.bouteilles.filter(
                    bouteille => bouteille.vin_id === vin_id
                );
            }
            return [];
        },
        callbackFamille(reload, famille) {
            if (reload) {
                this.getFamilles();
            }
            if (famille) {
                Object.assign(this.activeFamille, famille);
            }
        },
        callbackVin(reload, vin) {
            if (reload) {
                this.getFamilles();
                this.getVins();
            }
            if (vin) {
                Object.assign(this.activeVin, vin);
            }
        },
        callbackBouteille(reload, bouteille) {
            if (reload) {
                console.log('reload this.activeAllocationId:' + this.activeAllocationId);
                this.getFamilles();
                this.getVins();
                this.getBouteilles(this.activeAllocationId);
            }
            if (bouteille) {
                Object.assign(this.activeBouteille, bouteille);
            }
        },
        endDragFamilles(e) {
            // console.log('dragid:' + e.clone.id + ' old:' + e.oldIndex + ' new:' + e.newIndex);
            familleResource
                .update(e.clone.id, { position: e.newIndex })
                .then(() => {
                    this.$message({
                        message: "Ordre des familles mis à jour",
                        type: "success",
                        duration: 5 * 1000
                    });
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        endDragVins(e) {
            // console.log('dragid:' + e.clone.id + ' old:' + e.oldIndex + ' new:' + e.newIndex);
            vinResource
                .update(e.clone.id, { position: e.newIndex })
                .then(() => {
                    this.$message({
                        message: "Ordre des vins mis à jour",
                        type: "success",
                        duration: 5 * 1000
                    });
                    this.vins = [];
                    this.familles = [];
                    this.getFamilles();
                    this.getVins();
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
